document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.querySelector('.product-sticky-cart');

  if (!stickyCart) {
    console.log('Sticky cart not found');
    return;
  }

  const getHeaderHeight = () => {
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    if (!header) return 0;
    return Math.round(header.getBoundingClientRect().height);
  };

  const setStickyPosition = () => {
  stickyCart.style.setProperty('position', 'fixed', 'important');
  stickyCart.style.setProperty('top', 'auto', 'important');
  stickyCart.style.setProperty('bottom', '0', 'important');
  stickyCart.style.setProperty('left', '0', 'important');
  stickyCart.style.setProperty('right', '0', 'important');
  stickyCart.style.setProperty('width', '100%', 'important');
  stickyCart.style.setProperty('z-index', '9999', 'important');
  stickyCart.style.setProperty('transform', 'none', 'important');
};

  const hideStickyCart = () => {
    stickyCart.style.setProperty('opacity', '0', 'important');
    stickyCart.style.setProperty('visibility', 'hidden', 'important');
    stickyCart.style.setProperty('pointer-events', 'none', 'important');
  };

  const showStickyCart = () => {
    setStickyPosition();
    stickyCart.style.setProperty('opacity', '1', 'important');
    stickyCart.style.setProperty('visibility', 'visible', 'important');
    stickyCart.style.setProperty('pointer-events', 'auto', 'important');
  };

  hideStickyCart();

  function updateStickyCart(productButton) {
    const rect = productButton.getBoundingClientRect();
    const headerHeight = getHeaderHeight();
    if (rect.bottom > headerHeight && rect.top < window.innerHeight) {
      hideStickyCart();
      return;
    }
    showStickyCart();
  }

  // Wait for the quote button to appear (handles dynamically loaded buttons)
  function waitForButton(attempts = 0) {
    const productButton = Array.from(
      document.querySelectorAll('.omgrfq-btn-quotes, .product-form__submit')
    ).find(btn => !btn.closest('.product-sticky-cart') && !btn.closest('animate-sticky'));

    if (productButton) {
      console.log('Quote/ATC button found:', productButton.className);
      window.addEventListener('scroll', () => updateStickyCart(productButton), { passive: true });
      window.addEventListener('resize', () => updateStickyCart(productButton));
      updateStickyCart(productButton);
      console.log('Sticky cart behavior loaded');
      return;
    }

    if (attempts < 20) {
      setTimeout(() => waitForButton(attempts + 1), 300);
    } else {
      console.log('Button not found after retries — sticky cart stays hidden');
    }
  }


  waitForButton();
});
